// src/dashboard/pages/teacher/Objectifs/components/ObjectifsKpiCards.jsx

import React from "react";
import {
  FaBullseye,
  FaCheckCircle,
  FaRunning,
  FaUsers,
} from "react-icons/fa";

function SkeletonCard() {
  return (
    <div className="h-28 animate-pulse rounded-[24px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900" />
  );
}

function KpiCard({ label, value, helper, icon, tone = "base" }) {
  const tones = {
    base: "bg-indigo-50 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300",
    green:
      "bg-emerald-50 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300",
    amber:
      "bg-amber-50 text-amber-700 dark:bg-amber-500/10 dark:text-amber-300",
    rose: "bg-rose-50 text-rose-700 dark:bg-rose-500/10 dark:text-rose-300",
  };

  return (
    <article className="rounded-[24px] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-[11px] uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
            {label}
          </p>

          <p className="mt-2 text-2xl font-bold text-slate-900 dark:text-white">
            {value}
          </p>

          {helper ? (
            <p className="mt-1 text-xs leading-5 text-slate-500 dark:text-slate-400">
              {helper}
            </p>
          ) : null}
        </div>

        <span
          className={`inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl ${tones[tone]}`}
        >
          {icon}
        </span>
      </div>
    </article>
  );
}

export default function ObjectifsKpiCards({ stats, loading }) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {[...Array(4)].map((_, index) => (
          <SkeletonCard key={index} />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
      <KpiCard
        label="Objectifs affichés"
        value={stats.filtered}
        helper={`${stats.total} objectif(s) au total.`}
        icon={<FaBullseye />}
        tone="base"
      />

      <KpiCard
        label="Terminés"
        value={stats.done}
        helper={`${stats.todo} objectif(s) encore en cours.`}
        icon={<FaCheckCircle />}
        tone="green"
      />

      <KpiCard
        label="Progression moyenne"
        value={`${stats.progressAverage}%`}
        helper="Moyenne de progression globale."
        icon={<FaRunning />}
        tone="amber"
      />

      <KpiCard
        label="Adhérents suivis"
        value={stats.adherents}
        helper={`${stats.types} type(s) d’objectif utilisé(s).`}
        icon={<FaUsers />}
        tone="rose"
      />
    </div>
  );
}